import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { filter } from 'rxjs/operators';

import { CompanySettingsServiceHelper } from '../settings/services/company-settings-helper.service';
import { CompanySettingsService } from '../settings/services/company-settings.service';

@Injectable()
export class AllowIrsReportingResolver implements Resolve<boolean> {
  private belongsToCountrySubject: BehaviorSubject<
    boolean
  > = new BehaviorSubject(null);
  private _belongsToCountry$: Observable<
    boolean
  > = this.belongsToCountrySubject.asObservable();

  constructor(
    private companySettingsServiceHelper: CompanySettingsServiceHelper,
    private compannySettings: CompanySettingsService
  ) {
    this.compannySettings.companySettingsChanged$.subscribe(
      (isChanged: boolean) => {
        if (isChanged) {
          this.checkBelongsToCountry();
        }
      }
    );
  }

  public resolve(): Observable<boolean> {
    return this._belongsToCountry$.pipe(
      filter((result: boolean) => result != null)
    );
  }

  private checkBelongsToCountry(): void {
    this.companySettingsServiceHelper
      .isCompanyIn('us')
      .subscribe((belongsTo: boolean) =>
        this.belongsToCountrySubject.next(belongsTo)
      );
  }
}
